import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["object", "variant"]
  static values = {
    variants: Array,
    objectType: String
  }

  connect() {
    // If a variant is already selected but no object is selected,
    // we need to find and select the object first
    const currentVariantId = parseInt(this.variantTarget.value)
    const objectId = this.hasObjectTarget ? parseInt(this.objectTarget.value) : null

    if (currentVariantId && !objectId && this.hasObjectTarget) {
      // Find the object for this variant
      const variant = this.variantsValue.find(v => v.id === currentVariantId)
      if (variant) {
        this.objectTarget.value = this.getObjectIdFromVariant(variant)
      }
    }

    this.updateVariants()
  }

  updateVariants() {
    if (!this.hasObjectTarget || !this.hasVariantTarget) return

    const objectId = parseInt(this.objectTarget.value)
    const variantSelect = this.variantTarget
    const currentVariantId = variantSelect.value

    // Clear current options
    variantSelect.innerHTML = '<option value="">Select a variant</option>'

    if (!objectId) {
      variantSelect.disabled = true
      return
    }

    // Filter variants for selected object
    const filteredVariants = this.variantsValue.filter(v => {
      return this.getObjectIdFromVariant(v) === objectId
    })

    if (filteredVariants.length === 0) {
      variantSelect.disabled = true
      const option = document.createElement('option')
      option.value = ''
      option.textContent = 'No variants available'
      variantSelect.appendChild(option)
      return
    }

    // Add filtered variants
    let hasSelectedVariant = false
    let favoriteVariant = null
    
    filteredVariants.forEach((variant, index) => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name
      
      if (variant.id === parseInt(currentVariantId)) {
        option.selected = true
        hasSelectedVariant = true
      }
      
      // Track the favorite variant
      if (variant.favorite) {
        favoriteVariant = variant
      }
      
      variantSelect.appendChild(option)
    })

    // If no variant was selected and we have variants, select the favorite or the first one
    if (!hasSelectedVariant && filteredVariants.length > 0) {
      if (currentVariantId) {
        variantSelect.value = currentVariantId
      } else if (favoriteVariant) {
        // Pre-select the favorite variant
        variantSelect.value = favoriteVariant.id
      }
    }

    variantSelect.disabled = false
  }

  // Get the object ID from a variant based on the object type
  getObjectIdFromVariant(variant) {
    // Try different possible field names
    const possibleFields = [
      'perfumed_candle_id',
      'wax_melt_id',
      'jesmonite_object_id',
      'molded_candle_id',
      'object_id'
    ]

    for (const field of possibleFields) {
      if (variant[field] !== undefined) {
        return variant[field]
      }
    }

    return null
  }
}

